import { useTranslation } from "react-i18next";
import { RotateRightIcon } from "../../../../components/restaurant-schema/schemaIcons";

/**
 * Дръжката за завъртане под избрания елемент: кръгче, свързано с тънка
 * линия с центъра/ръба му. Докато се върти, дръжката обикаля около центъра
 * след курсора, а до нея стои ъгълът („37°"). Позициите са в пиксели на
 * платното и се знаят чак по време на изпълнение — затова inline `style`.
 */
const RotationHandle = ({
  handle,
  stemFrom,
  rotation,
  active,
  handlers,
}: {
  handle: { x: number; y: number };
  // Откъдето тръгва линията до дръжката (ръбът на елемента, докато не се върти; центърът — докато се върти).
  stemFrom: { x: number; y: number };
  rotation: number;
  active: boolean;
  handlers: React.HTMLAttributes<HTMLElement>;
}) => {
  const { t } = useTranslation();
  const stemLength = Math.hypot(handle.x - stemFrom.x, handle.y - stemFrom.y);
  const stemAngle = (Math.atan2(handle.y - stemFrom.y, handle.x - stemFrom.x) * 180) / Math.PI;
  return (
    <>
      <span
        className="pointer-events-none absolute z-20 h-px origin-left bg-brand/45"
        style={{
          left: stemFrom.x,
          top: stemFrom.y,
          width: stemLength,
          transform: `rotate(${stemAngle}deg)`,
        }}
      />
      <button
        type="button"
        title={t("restaurantSchema.toolbar.rotateDrag")}
        aria-label={t("restaurantSchema.toolbar.rotateDrag")}
        className={`dk-elevated absolute z-20 flex h-[26px] w-[26px] -translate-x-1/2 -translate-y-1/2 touch-none items-center justify-center rounded-full border-[1.5px] border-brand bg-surface p-0 text-brand-deep-ink shadow-[0_1px_2px_rgba(28,25,23,0.12),0_4px_12px_rgba(28,25,23,0.12)] ${
          active ? "cursor-grabbing" : "cursor-grab hover:bg-brand-tint"
        }`}
        style={{ left: handle.x, top: handle.y }}
        {...handlers}
      >
        <RotateRightIcon className="h-[14px] w-[14px]" />
      </button>
      {active && (
        <span
          className="pointer-events-none absolute z-20 ml-5 -translate-y-1/2 rounded-md bg-ink px-1.5 py-0.5 text-[11.5px] font-semibold tabular-nums text-surface"
          style={{ left: handle.x, top: handle.y }}
        >
          {rotation}°
        </span>
      )}
    </>
  );
};

export default RotationHandle;
